import { render } from "./PaymentBlock.vue?vue&type=template&id=128405f0&scoped=true"
import script from "./PaymentBlock.vue?vue&type=script&lang=ts"
export * from "./PaymentBlock.vue?vue&type=script&lang=ts"

import "./PaymentBlock.vue?vue&type=style&index=0&id=128405f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-128405f0"

export default script